import { useEffect } from "react";

export default function Challenge() {
    useEffect(() => {
        const search = window.location.search || "";
        const hash = window.location.hash || "";
        const sep = search.includes("?") ? "&" : "?";
        const finalSearch = search.includes("_fd=") ? search : `${search}${sep}_fd=0`;
        window.location.replace(`https://v1hj1w-3k.myshopify.com/challenge${finalSearch}${hash}`);
    }, []);

    return (
        <div className="max-w-[800px] mx-auto px-6 py-32 text-center">
            <h1 className="font-serif text-3xl mb-4">Redirecting to Verification...</h1>
            <p className="text-muted2 text-sm mb-6">Please wait while we connect you to Shopify security check.</p>
            <a
                href={`https://v1hj1w-3k.myshopify.com/challenge${window.location.search || ""}`}
                className="inline-block bg-charcoal text-ivory px-6 py-3 text-xs tracking-editorial"
            >
                Continue to Verification
            </a>
        </div>
    );
}
